import { render, staticRenderFns } from "./ListenChannel.vue?vue&type=template&id=5d3978ff&"
import script from "./ListenChannel.vue?vue&type=script&lang=js&"
export * from "./ListenChannel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports